import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.events = {
            change: 'filter'
        }
        this.filters = this.el.querySelectorAll('[data-avantages-input]');
        this.filters.forEach(filter => {
            filter.addEventListener('change', (e) => {
                this.filter(e);
                console.log('change');
            });
        });
        console.log('init');
    }

    filter(e) {
        let selectedValue = e.target.value;
        let allItems = this.el.querySelectorAll('[data-avantages-item]');
        allItems.forEach(item => {
            if (selectedValue === 'all') {
                item.classList.remove('is-hidden');
            } else {
                if (item.dataset.termId !== selectedValue) {
                    item.classList.add('is-hidden');
                } else {
                    item.classList.remove('is-hidden');
                }
            }
        });
    }

    destroy() {
        this.filters.forEach(filter => {
            filter.removeEventListener('change', this.filter);
        });
    }
}

/*

<?php 
    // get all taxo avantage_cat
    $terms = get_terms([
        'taxonomy' => 'avantage_cat',
        'hide_empty' => true,
    ]);

?>
<div class="c-avantages-membre-filters" data-module="AvantagesFilters">
    <div class="c-avantages-membre-filters__item">
            <div class="o-form-group o-radio__group">
                <div class="o-radio__wrap">
                    <input class="o-radio" type="radio" name="avantage-radio" id="avantage-radio-all" value="all" checked>
                <label class="o-radio-label" for="avantage-radio-all">
                    Afficher tout
                </label>
            </div>
        </div>
    </div>
    <?php // Loop through each term and create a filter item
    foreach ($terms as $term) {
        $term_name = $term->name;
        $term_slug = $term->slug;
        $term_id = $term->term_id;
        ?>
        <div class="c-avantages-membre-filters__item">
            <div class="o-form-group o-radio__group">
                <div class="o-radio__wrap">
                    <input class="o-radio" type="radio" name="avantage-radio" id="avantage-radio-<?= esc_attr($term_id); ?>" value="<?= esc_attr($term_id); ?>">
                    <label class="o-radio-label" for="avantage-radio-<?= esc_attr($term_id); ?>">
                        <?= esc_html($term_name); ?>
                    </label>
                </div>
            </div>
        </div>
    <?php } ?>
</div>


 */